import { createContext } from "react";

const uid = window.location.pathname.split("/")[2];

console.log("MemberUidContext", uid)

export const MemberUidContext = createContext(uid);